module.exports = __webpack_public_path__ + "static/media/productdesign.3eab63c8.svg";